<template>
  <div class="animated fadeIn" @keyup.enter="onFilter">
    <div class="form-group row">
      <div class="col-md-12">
        <label> Lista:</label>
        <div class="input-group mb-3">
          <b-form-input
            type="text"
            :placeholder="'Digite o Nome da lista'"
            v-model="form.nome.value"
            :state="form.nome.state"
            autofocus
          />
        </div>
      </div>

      <div class="col-md-12">
        <label> Ultima Ação Executada:</label>
        <div class="input-group mb-3">
          <v-select
            multiple
            v-model="form.ultimaAcaoExecutada.value"
            :options="form.ultimaAcaoExecutada.options"
            :reduce="x => x.value"
            class="w-100"
            label="text"
            placeholder="Selecione o Tipo de Pessoa"
          >
            <template v-slot:no-options>{{
              $lang.Common.PlaceholderSelect
            }}</template>
          </v-select>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12 pt-2">
        <button type="button" class="btn btn-third w-100" v-on:click="onFilter">
          Filtrar
        </button>
      </div>
      <div class="col-md-12 pt-2">
        <button
          type="button"
          class="btn btn-default w-100"
          v-on:click="onClearFilters"
        >
          Limpar Filtros
        </button>
      </div>
    </div>
    <div class="form-group row" style="margin-top: 250px;">
      &nbsp;<!--Space to scroll-->
    </div>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'

const ListaInteligenteSearchModel = {
  nome: null,
  ultimaAcaoExecutada: null
}

const ListaInteligenteSearchForm = {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  ultimaAcaoExecutada: {
    value: null,
    options: [
      {text: 'Abrir Card', value: 'OPEN_CARD'},
      {text: 'Criar Lista Campanha', value: 'CREATE_LIST_CAMPAIGN'},
      {text: 'Enviar E-mail', value: 'SEND_EMAIL'},
      {text: 'Enviar SMS', value: 'SEND_SMS'},
      {text: 'Enviar WhatsApp', value: 'SEND_WHATSAPP'},
      {text: 'Exportar Excel', value: 'EXPORT_EXCEL'}
    ],
    required: false,
    state: null
  }
}

export default {
  mixins: [ActionsForm],
  name: 'ListaInteligenteSearch',
  data () {
    return {
      data: ListaInteligenteSearchModel,
      form: ListaInteligenteSearchForm
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  methods: {
    onLoad () {
      this.onClearFilters()
    },
    onClearFilters () {
      Tools.SetFormDefaultValues(this.form)
      this.parentComponent.filters = null
      this.parentComponent.onLoad()
    },
    onValidateFilters () {
      let result = true
      Tools.SetValueToSave(this.form, this.data)
      return result
    },
    onFilter () {
      if (this.onValidateFilters()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/search/search.vue